import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PATINPerfis.css";

const API = "/api/patin/auth";

export default function PATINLogin() {
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(false);

  async function entrar(event) {
    event.preventDefault();
    setErro("");
    setCarregando(true);

    try {
      const resposta = await fetch(`${API}/login`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ usuario, senha })
      });

      const dados = await resposta.json();

      if (!resposta.ok) {
        throw new Error(dados.detail || "Não foi possível entrar.");
      }

      if (dados.usuario.perfil === "consultora") {
        navigate("/patin/mentora", { replace: true });
      } else if (dados.usuario.perfil === "empreendedora") {
        navigate("/patin/meu-plano", { replace: true });
      } else {
        throw new Error("Perfil não autorizado.");
      }
    } catch (error) {
      setErro(error.message);
    } finally {
      setCarregando(false);
    }
  }

  return (
    <main className="patin-perfis">
      <section className="patin-login-card">
        <div className="patin-etiqueta">NUNCA FOI SÓ BATOM</div>

        <h1>PATIN Digital</h1>

        <p>
          Acesse seu espaço de acompanhamento,
          diagnóstico e transformação do negócio.
        </p>

        <form onSubmit={entrar}>
          <label htmlFor="patin-usuario">Usuário</label>

          <input
            id="patin-usuario"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            placeholder="Digite seu usuário"
            autoComplete="username"
            required
          />

          <label htmlFor="patin-senha">Senha</label>

          <input
            id="patin-senha"
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            placeholder="Digite sua senha"
            autoComplete="current-password"
            required
          />

          {erro && (
            <div className="patin-erro" role="alert">
              {erro}
            </div>
          )}

          <button type="submit" disabled={carregando}>
            {carregando ? "Entrando..." : "Entrar no PATIN"}
          </button>
        </form>

        <small>
          Acesso exclusivo para participantes e mentoras autorizadas.
        </small>
      </section>
    </main>
  );
}
